/* eslint-disable react-refresh/only-export-components */
import * as Constants from './constants';
import { CalculatorBag } from './types';
import { CalculatorInput } from './CalculatorInput';
import { CalculatorOutput } from './CalculatorOutput';
import { CalculatorDescription } from './CalculatorDescription';

export const calculatorBag: CalculatorBag = {
  key: Constants.KEY,
  Input: CalculatorInput,
  Output: CalculatorOutput,
  Description: CalculatorDescription,
};

export * from './types';
export * from './constants';
